// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Output of feedback component: student comment
 */
export interface LegacyScoresOutput {
  /**
   * @minimum 1
   * @maximum 10
   */
  TW_Cr1: number;
  /**
   * @minimum 1
   * @maximum 10
   */
  TW_Cr2: number;
  /**
   * @minimum 1
   * @maximum 5
   */
  TW_Cr3: number;
  /**
   * @minimum 1
   * @maximum 5
   */
  TW_Cr4: number;
  /**
   * @minimum 1
   * @maximum 5
   */
  TW_Cr5: number;
  /**
   * @minimum 1
   * @maximum 5
   */
  TW_Cr6: number;
  /**
   * @minimum 1
   * @maximum 5
   */
  TW_Cr7: number;
}
